export const APP_DETAILS = "APP_DETAILS";
export const BANK_DETAILS = "BANK_DETAILS";
export const BANNERS = "BANNERS";
export const SHOW_RIGHT_SIDEBAR = "SHOW_RIGHT_SIDEBAR";
export const POST_LOGIN_MODAL = "POST_LOGIN_MODAL";
